import { CustomerSchema } from "@redotech/redo-customer-common/customer";
import * as z from "zod";

export const getOrCreateCustomerFromPhoneNumber = {
  name: "getOrCreateCustomerFromPhoneNumber" as const,
  input: z.object({ number: z.string() }),
  output: CustomerSchema,
};
